import dayjs from '~/plugins/dayjs.js';
global['dayjs'] = dayjs

import firebase from '~/plugins/firebase.js';
global['firebase'] = firebase

import app from '~/scripts/app.js';
global['app'] = app

import QuerySearch from 'querysearch';
global['QuerySearch'] = QuerySearch

import '~/styles/main.less';
